import { RotationConfig } from '../RotationConfig';
import RotationReplacer from '../RotationReplacer';
import { doWhenP } from '../utils';
import { fetchTokenNumbers } from '../Mapi';
import { getRequestId, getPromoCode } from '../dataLayer';
export function getRotationConfig() {
    var _a;
    return (_a = window.MAPI) === null || _a === void 0 ? void 0 : _a.config;
}
export function getRotation() {
    var _a;
    return (_a = window.MAPI) === null || _a === void 0 ? void 0 : _a.Rotation;
}
export function replacePhoneNumbers() {
    return doWhenP(() => { var _a; return (_a = window.MAPI) === null || _a === void 0 ? void 0 : _a.refreshNumbers; }, 1000).then(() => window.MAPI.refreshNumbers());
}
export function run() {
    return doWhenP(() => getPromoCode() && getRequestId() && getRotationConfig()).then(() => {
        window.MAPI.Rotation = window.MAPI.Rotation || new RotationConfig({});
        const repl = new RotationReplacer();
        const rot = window.MAPI.Rotation;
        rot.setConfig(getRotationConfig());
        repl.setConfig(rot);
        window.MAPI.refreshNumbers = repl.replaceRotated.bind(repl);
        window.MAPI.watchForNumbers = repl.watchForReplacement.bind(repl);
        window.MAPI.replacePhoneNumbers = window.MAPI.refreshNumbers; // renaming to not break backward compat
        window.MAPI.fetchTokenNumbers = fetchTokenNumbers;
        return repl;
    });
}
//# sourceMappingURL=RotationBase.js.map